import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { MSmClientOpportunityEntity } from './m-sm-client-opportunity.entity';

@Index('client_note__fk_client__id_fk', ['fkClientId'], {})
@Index('client_note_externalId_uindex', ['deletedUserId', 'externalId'], {
	unique: true,
})
@Index(
	'm_sm_fk_m_sm_client_opportunity__id',
	['mSmFkMSmClientOpportunityId'],
	{},
)
@Entity('client_note')
export class ClientNoteEntity extends BaseEntity {
	@Column('int', { name: '_fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('text', { name: 'text', nullable: true })
	public text!: string | null;

	@Column('varchar', { name: 'externalId', nullable: true, length: 255 })
	public externalId!: string | null;

	@Column('datetime', { name: 'lastImportDate', nullable: true })
	public lastImportDate!: Date | null;

	@Column('int', {
		name: 'm_sm_fk_m_sm_client_opportunity__id',
		nullable: true,
		unsigned: true,
	})
	public mSmFkMSmClientOpportunityId!: number | null;

	@Column('datetime', { name: 'dateTime', default: () => 'CURRENT_TIMESTAMP' })
	public dateTime!: Date;

  @Column("tinyint", { name: "isPinned", default: () => "'0'", width: 1 })
  isPinned!: number;

  @OneToMany(() => ClientEntity, (client) => client.fkClientNote, { lazy: true })
  clients!: Promise<ClientEntity[]>;

	@ManyToOne(
		() => MSmClientOpportunityEntity,
		(mSmClientOpportunity) => mSmClientOpportunity.clientNotes,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: 'm_sm_fk_m_sm_client_opportunity__id', referencedColumnName: 'id' },
	])
	public mSmFkMSmClientOpportunity!: MSmClientOpportunityEntity;

	@ManyToOne(() => ClientEntity, (client) => client.clientNotes, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;
}
